import React, { useState } from 'react';
import useApi from '../hooks/useApi';

export default function ContactUsPage() {
  const [errors, setErrors] = useState({});
  const { request } = useApi();
  const [formData, setFormData] = useState({
    email: '',
    subject: '',
    message: '',
  });
  const [status, setStatus] = useState('');

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setStatus('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('');
    
    const newErrors = {};
    if (!formData.email.trim()) newErrors.email = 'Email is required';
    if (!formData.message.trim()) newErrors.message = 'Message is required';
    if (!formData.subject.trim()) newErrors.subject = 'Subject is required!';

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      setStatus('error');
      return;
    }

    setErrors({});
    setStatus('loading');

    try {
      const response = await request({
        method: 'post',
        url: `api/v1/users/contactus/`,
        data: formData,
        withAuth: true,
      });

      setStatus('success');
      setFormData({ email: '', subject: '', message: '' });
    } catch (error) {
      console.error(error);
      setStatus('error');
    }
  };

  return (
    <div className="max-w-4xl mx-auto px-6 py-20 text-gray-800">
      <h1 className="text-4xl font-bold mb-4 text-center">Contact Us</h1>
      <p className="text-lg text-gray-600 mb-10 text-center max-w-xl mx-auto">
        We'd love to hear from you! Whether it's feedback, questions, or collaboration ideas — we're here to help.
      </p>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
        {/* Contact Form */}
        <form onSubmit={handleSubmit} className="bg-white p-6 rounded shadow-md border">
          <div className="mb-4">
            <label className="block mb-1 font-medium">Email Address</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              className="w-full border rounded px-3 py-2"
              placeholder="you@example.com"
            />
          </div>
          {errors.email && <p className="text-red-600 text-sm mt-1">{errors.email}</p>}
          <div className="mb-4">
            <label className="block mb-1 font-medium">Subject</label>
            <select
              name="subject"
              value={formData.subject}
              onChange={handleChange}
              className="w-full border rounded px-3 py-2"
            >
              <option value="">Select a topic</option>
              <option value="Feedback">Feedback</option>
              <option value="Bug Report">Bug Report</option>
              <option value="Partnership">Partnership</option>
              <option value="Other">Other</option>
            </select>
          </div>
          {errors.subject && <p className="text-red-600 text-sm mb-2 text-center">{errors.subject}</p>}
          <div className="mb-4">
            <label className="block mb-1 font-medium">Message</label>
            <textarea
              name="message"
              value={formData.message}
              onChange={handleChange}
              required
              rows={5}
              className="w-full border rounded px-3 py-2"
              placeholder="Type your message..."
            />
          </div>
          {errors.message && <p className="text-red-600 text-sm mt-1">{errors.message}</p>}
          <button
            type="submit"
            disabled={status === 'loading'}
            className="bg-blue-600 text-white px-6 py-2 rounded hover:bg-blue-700 transition w-full disabled:opacity-50"
          >
          {status === 'loading' ? 'Sending your message...' : 'Send Message'}
          </button>
          {status === 'success' && (
            <p className="mt-4 text-green-600 text-sm text-center">Thanks for contacting us! We'll get back soon.</p>
          )}
          {status === 'error' && Object.keys(errors).length === 0 && (
            <p className="mt-4 text-red-600 text-sm text-center">Something went wrong. Please try again.</p>
          )}
        </form>

        {/* Contact Info & Socials */}
        <div className="space-y-6">
          <div>
            <h3 className="text-xl font-semibold mb-2">Direct Contact</h3>
            <p className="text-sm">📧 <a href="mailto:poppyruz_support@gmail.com" className="text-blue-600 hover:underline">mohamedzindha21@gmail.com</a></p>
            <p className="text-sm">📍 Tirunelveli, India</p>
          </div>

          <div>
            <h3 className="text-xl font-semibold mb-2">Follow Us</h3>
            <div className="flex space-x-4">
              <a href="https://www.instagram.com/zindha_madhar" target="_blank" rel="noopener noreferrer">
                <img src="/icons/instagram.svg" alt="Instagram" className="h-5 w-5" />
              </a>
              <a href="https://www.linkedin.com/in/mohamed-sindha-madhar-a9525822a" target="_blank" rel="noopener noreferrer">
                <img src="/icons/linkedin.svg" alt="LinkedIn" className="h-5 w-5" />
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-xl font-semibold mb-2">Quick Help</h3>
            <p className="text-sm">Looking for quick answers? <a href="/faq" className="text-blue-600 hover:underline">Check our FAQ</a>.</p>
          </div>
        </div>
      </div>
    </div>
  );
}
